import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsFinanceByWorkTypes: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE].GET_REPORTS_FINANCE_BY_WORK_TYPE,
	},
}
